import { render, staticRenderFns } from "./AnswerListView.vue?vue&type=template&id=443f5f3a&scoped=true"
import script from "./AnswerListView.vue?vue&type=script&lang=js"
export * from "./AnswerListView.vue?vue&type=script&lang=js"
import style0 from "./AnswerListView.vue?vue&type=style&index=0&id=443f5f3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f5f3a",
  null
  
)

export default component.exports